"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callWalletPopup = exports.CallMethod = void 0;
const jsontokens_1 = require("jsontokens");
var CallMethod;
(function (CallMethod) {
    CallMethod["SIGN_TRANSACTION"] = "signTransaction";
    CallMethod["GET_ADDRESS"] = "getAddress";
})(CallMethod = exports.CallMethod || (exports.CallMethod = {}));
const callWalletPopup = async (options) => {
    const provider = window.BitcoinProvider;
    const { method } = options.payload;
    if (!provider) {
        throw new Error('No Bitcoin Wallet installed');
    }
    if (!method) {
        throw new Error('A wallet method is required');
    }
    const request = (0, jsontokens_1.createUnsecuredToken)(options.payload);
    try {
        const callResponse = await provider.call(request);
        options.onFinish?.(callResponse);
    }
    catch (error) {
        console.error('[Connect] Error during call request', error);
        options.onCancel?.();
    }
};
exports.callWalletPopup = callWalletPopup;
//# sourceMappingURL=index.js.map